import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { accessToken, Login } from '../models/login.model';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private readonly APIurl = environment.apis;
  constructor(
    private http: HttpClient
  ) {

  }

  logIn(login: Login) {
    const headers = new HttpHeaders({
      'content-type': 'application/json; charset=utf-8'
    });
    let options = { headers: headers };

    const payload = login;

    return this.http.post<accessToken>(this.APIurl + "/login", payload, options);
  }
}
